import React from 'react';
import classNames from 'classnames';
import styles from '../../style/slider.module.scss';
import {BaseProps} from "../../../../../infrastructure/models/props/base-props";

export class SliderWidgetCardCenterTextProps extends BaseProps {
  text: String;
}

export const SliderGameCardCenterText = ({text}: SliderWidgetCardCenterTextProps) => {
  const containerProps = {
    className: classNames(styles.slider_widget_card_center_text)
  };

  return (
    <div {...containerProps}>
      {
        text
      }
    </div>
  )
};
